import React, { useContext, useEffect, useState } from "react";
import "../../../../assets/css/user/signup/Signup.css";
import {
  FaUser,
  FaEnvelope,
  FaLock,
  FaEyeSlash,
  FaEye,
  FaApple,
  FaFacebook,
  FaGoogle,
} from "react-icons/fa";
import AppContext from "../../../../context/AppContext";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import { Spinner } from "react-bootstrap";
import Swal from "sweetalert2";

const Signup = () => {
  const navigate = useNavigate();

  const { baseUrl, setUser, regTpChecker, setIsLogin } = useContext(AppContext);

  const [fullname, setFullname] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [remember, setRemember] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isSignUpLoading, setIsSignUpLoading] = useState(false);
  const handleSocialLogin = (provider) => {
    alert(`${provider} login will be implemented here`);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const fullNameError = regTpChecker("fullName", fullname);
    const emailError = regTpChecker("email", email);
    const passwordError = regTpChecker("password", password);

    console.log("Full Name Error:", fullNameError);
    console.log("Email Error:", emailError);
    console.log("Password Error:", passwordError);
    const error = fullNameError || emailError || passwordError;

    if (error) {
      setErrorMessage(error);
      return;
    }

    setIsSignUpLoading(true);

    const formdata = new FormData();
    formdata.append("fullname", fullname);
    formdata.append("email", email);
    formdata.append("password", password);

    axios
      .post(`${baseUrl}/customer/auth/signup`, formdata)
      .then((response) => {
  setIsSignUpLoading(false);

  if (response.data.error) {
    setErrorMessage(response.data.error);
  } else {
    localStorage.setItem("userEmail", email);
    localStorage.setItem("userPassword", password);

    localStorage.setItem(
      "loggedInUser",
      JSON.stringify(response.data.customer)
    );

    // Update AppContext immediately
    setUser(response.data.customer);
    setIsLogin(true);

    // Tell Navbar that login has happened
    window.dispatchEvent(new Event("loginUpdated"));

    Swal.fire({
      icon: "success",
      title: "Success!",
      text: "Account Created Successfully",
      confirmButtonColor: "#198754",
    }).then(() => {
      navigate("/");
    });
  }
})
      .catch((error) => {
        console.log(error);
        setErrorMessage("Email already exists!");
        setIsSignUpLoading(false);
      });
  };
  useEffect(() => {
    const savedEamil = localStorage.getItem("userEmail");
    const savedPassword = localStorage.getItem("userPassword");
    if (savedEamil != null && savedPassword != null) {
      setIsLoading(true);
      navigate("/");
    }
  }, [navigate]);

  return isLoading == true ? (
    <div
      style={{ height: 50 }}
      className="d-flex justify-content-center align-item-center"
    >
      <Spinner style={{ height: 50, width: 50, fontsize: 60 }} />
    </div>
  ) : (
    <>
      <div className="signup-page">
        <div className="signup-container">
          {/* Left Side */}
          <div className="signup-left">
            <div className="left-content">
              <h1>Welcome Back!</h1>
              <p>Sign in to access amazing deals and exclusive offers</p>

              <div className="feature-box">🎁 Exclusive Deals</div>
              <div className="feature-box">⚡ Instant Access</div>
              <div className="feature-box">💰 Save Up to 75%</div>
              <div className="feature-box">🔒 Secure & Private</div>
            </div>
          </div>

          {/* Right Side */}
          <div className="signup-right">
            <div className="form-box">
              <h2>Sign Up</h2>
              <p>Create your account</p>

              {/* Social Login Buttons */}
              {/* <div className="social-login">
              <button
                className="social-btn google-btn"
                onClick={() => handleSocialLogin('Google')}
                type="button"
              >
                <FaGoogle /> Continue with Google
              </button> */}
              {/* 
              <button
                className="social-btn facebook-btn"
                onClick={() => handleSocialLogin('Facebook')}
                type="button"
              >
                <FaFacebook /> Continue with Facebook
              </button>

              <button
                className="social-btn apple-btn"
                onClick={() => handleSocialLogin('Apple')}
                type="button"
              >
                <FaApple /> Continue with Apple
              </button>
            </div> */}

              {/* <div className="divider">
              <span>OR</span>
            </div> */}
              {/* Error Message */}
              {errorMessage && (
                <div className="buyer-error-message">{errorMessage}</div>
              )}
              {/* Success Message */}
              {successMessage && (
                <div className="buyer-success-message">{successMessage}</div>
              )}

              <form onSubmit={handleSubmit}>
                <div className="form-group">
                  <label>Full Name</label>

                  <div className="input-wrapper">
                    <FaUser className="input-icon" />
                    <input
                      value={fullname}
                      placeholder="Enter your Full Name"
                      onChange={(e) => {
                        setFullname(e.target.value);
                        setErrorMessage(
                          regTpChecker("fullName", e.target.value),
                        );
                      }}
                      required
                    />
                  </div>
                </div>

                <div className="form-group">
                  <label>Email</label>
                  <div className="input-wrapper">
                    <FaEnvelope className="input-icon" />
                    <input
                      type="email"
                      placeholder="Enter your email"
                      value={email}
                      onChange={(e) => {
                        setEmail(e.target.value);
                        setErrorMessage(regTpChecker("email", e.target.value));
                      }}
                      required
                    />
                  </div>
                </div>
                <div className="form-group">
                  <label htmlFor="password">Password</label>

                  <div className="input-wrapper">
                    <FaLock className="input-icon" />

                    <input
                      type={showPassword ? "text" : "password"}
                      id="password"
                      placeholder="Enter your password"
                      value={password}
                      onChange={(e) => {
                        setPassword(e.target.value);
                        setErrorMessage(
                          regTpChecker("password", e.target.value),
                        );
                      }}
                      required
                    />

                    <span
                      className="password-toggle"
                      onClick={() => setShowPassword(!showPassword)}
                    >
                      {showPassword ? <FaEyeSlash /> : <FaEye />}
                    </span>
                  </div>
                </div>
                <label className="remember-me">
                  <input
                    type="checkbox"
                    checked={remember}
                    onChange={(e) => setRemember(e.target.checked)}
                  />
                  <span>Remember Me</span>
                </label>

                {errorMessage && <p className="error-text">{errorMessage}</p>}
                {isSignUpLoading ? (
                  <div
                    style={{ height: 50 }}
                    className="d-flex justify-content-center align-item-center"
                  >
                    <Spinner size="lg" />
                  </div>
                ) : (
                  <button type="submit" className="signup-btn">
                    Sign Up
                  </button>
                )}
              </form>

              <div className="form-footer">
                <p>
                  Already have an account?{" "}
                  <Link to="/login" className="register-link">
                    Login
                  </Link>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Signup;
